import Button from "@mui/material/Button";
import Paper from "@mui/material/Paper";
import Stack from "@mui/material/Stack";
import i18n from "../../../../../constants/i18n";
import { ONE_O_ONE_M_FILTER } from "../../../../../constants/picker-entries-constants";
import { withLiteObserverAndTheme } from "../../../../../core/et3-enhanced-render";
import getKhattabatFilterStore from "../../../../../stores/khattabat-stores/filter-store";
import getKhattabatSelectsStore from "../../../../../stores/khattabat-stores/selects-store";
import KhattabatFilterMultiSelect from "../../../khattabat-clients/filter/KhattabatFilterMultiSelect";

const KhattabatResultsFilters = withLiteObserverAndTheme(() => {
  const {
    filter1o1MSelectedTypes,
    setFilterSelected101MTypes,
    isSearching1o1MMatches,
    isActive1o1MFilter,
    reset1o1MFilters,
    handle1o1MFiltering
  } = getKhattabatFilterStore();

  return (
    <Paper variant="outlined" sx={{ p: 2 }}>
      <Stack
        direction="row"
        spacing={1.5}
        alignItems="center"
        flexWrap="wrap"
        useFlexGap
      >
        <Stack sx={{ minWidth: 240, flex: 1, maxWidth: 480 }}>
          <KhattabatFilterMultiSelect
            label={i18n.get("FILTERS")}
            options={ONE_O_ONE_M_FILTER}
            value={filter1o1MSelectedTypes.get()}
            onChange={(value) => {
              getKhattabatSelectsStore().initializeAndClearMarksStateWithClients(
                "matchResultPage"
              );
              setFilterSelected101MTypes(value);
            }}
          />
        </Stack>
        <Button
          variant="outlined"
          color="error"
          disabled={!isSearching1o1MMatches.get()}
          onClick={reset1o1MFilters}
        >
          {i18n.get("FILTERS_RESET")}
        </Button>
        <Button
          variant="contained"
          disabled={!isActive1o1MFilter.get()}
          onClick={handle1o1MFiltering}
        >
          {i18n.get("APPLY")}
        </Button>
      </Stack>
    </Paper>
  );
});

export default KhattabatResultsFilters;
